import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { DateService } from '@thewhite/react-global-module/lib/services';
import { DateType } from '@thewhite/react-global-module/lib/types';
import * as t from 'io-ts';
import ACCOUNT_TYPE, { AccountTypeEnumType } from '../enums/accountType';

export const UserAccountType = t.interface({
    id: t.string,
    type: AccountTypeEnumType,
    username: t.union([t.string, t.null, t.undefined]),
    createDate: t.union([DateType, t.null, t.undefined]),
});

export interface UserAccountDto extends t.TypeOf<typeof UserAccountType> {
}

class UserAccount {
    id: string;
    username: string | null;
    createDate: Date | null;
    type: SimpleObjectInterface;

    constructor(params: UserAccountDto) {
        this.id  = params.id;
        this.type = ACCOUNT_TYPE[params.type];
        this.username = params.username ?? null;
        this.createDate = DateService.getValidDate(params.createDate ?? null);
    }
}

export default UserAccount;
